import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "notification-header" }
const _hoisted_2 = { class: "title ml-s1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "pi pi-times" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "notification-subheader"
}
const _hoisted_6 = { class: "notification-content" }
const _hoisted_7 = { class: "gutter-y-s2" }
const _hoisted_8 = {
  key: 1,
  class: "text-sm text-right mt-s3"
}

import { INotification } from '@/store/modules/notifications/models/notification.interface';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from '@/components/icon/Icon.vue';
import Spinner from '@/components/Spinner.vue';
import ExternalLink from '@/components/ExternalLink.vue';
import { getChainNameById } from '@/helpers/networkParams.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'Notification',
  props: {
    options: null
  },
  emits: ["closeNotification"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'closeNotification', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  options: INotification;
}




const { t } = useI18n();

const header = computed(() =>
  props.options.step
    ? t(`notification.${props.options.status}.stepHeader`, { ...props.options.step })
    : t(`notification.${props.options.status}.header`),
);
const subheader = computed(() => {
  if (props.options.subheader) {
    return props.options.subheader;
  }

  if (props.options.step?.chainId) {
    return t(`notification.subheader`, {
      chain: getChainNameById(props.options.step.chainId),
    });
  }

  return null;
});
const content = computed(() =>
  Array.isArray(props.options.content) ? props.options.content : [props.options.content],
);
const closeNotification = () => {
  emits('closeNotification', props.options.id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: ".notifications" }, [
    _createVNode(_TransitionGroup, {
      name: "notification",
      tag: "div"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(`notification ${__props.options.status}`),
          key: __props.options.id
        }, [
          _createElementVNode("div", _hoisted_1, [
            (__props.options.status === 'inProgress')
              ? (_openBlock(), _createBlock(Spinner, {
                  key: 0,
                  size: "20"
                }))
              : (_openBlock(), _createBlock(Icon, {
                  key: 1,
                  name: __props.options.status,
                  size: "20"
                }, null, 8, ["name"])),
            _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(header)), 1),
            _createElementVNode("button", {
              class: "notification-icon-close",
              onClick: closeNotification,
              type: "button"
            }, _hoisted_4)
          ]),
          (__props.options.step && _unref(subheader))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(subheader)), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(content), (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
              }), 128))
            ])
          ]),
          (__props.options.explorerLink)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(ExternalLink, {
                  label: _unref(t)('viewInExplorer'),
                  url: __props.options.explorerLink,
                  color: "default"
                }, null, 8, ["label", "url"])
              ]))
            : _createCommentVNode("", true)
        ], 2))
      ]),
      _: 1
    })
  ]))
}
}

})